import React, { useState } from 'react'
import './ImageGallery.css'

export default function ImageGallery({ images, compact = false }) {
  // Handle backward compatibility: accept either image_urls array or single image_url
  let imageArray = null

  if (!images) {
    return null
  }

  // If it's a string (single image_url), convert to array
  if (typeof images === 'string') {
    imageArray = [images]
  }
  // If it's already an array, use it
  else if (Array.isArray(images)) {
    imageArray = images
  }

  // Filter out null/undefined and only render if we have images
  imageArray = imageArray?.filter(Boolean) || []
  if (imageArray.length === 0) return null

  const imageUrls = imageArray

  const [selectedIndex, setSelectedIndex] = useState(null)

  const handleNext = () => {
    setSelectedIndex((prev) => (prev + 1) % imageUrls.length)
  }

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev - 1 + imageUrls.length) % imageUrls.length)
  }

  const handleClose = () => {
    setSelectedIndex(null)
  }

  if (compact) {
    // Single row for small spaces (like in responses)
    return (
      <div className="image-gallery-compact">
        {imageUrls.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Gallery image ${idx + 1}`}
            className="image-gallery-compact-img"
            loading="lazy"
            onClick={() => setSelectedIndex(idx)}
          />
        ))}
      </div>
    )
  }

  // Grid layout for capsule/main content
  return (
    <>
      <div className="image-gallery-grid">
        {imageUrls.map((img, idx) => (
          <div
            key={idx}
            className="image-gallery-grid-item"
            onClick={() => setSelectedIndex(idx)}
          >
            <img
              src={img}
              alt={`Gallery image ${idx + 1}`}
              loading="lazy"
            />
            {imageUrls.length > 1 && (
              <div className="image-gallery-grid-overlay">
                <span className="image-gallery-counter">
                  {idx + 1} / {imageUrls.length}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="image-gallery-lightbox" onClick={handleClose}>
          <button
            className="image-gallery-close"
            onClick={handleClose}
            title="Close"
          >
            ×
          </button>

          <img
            src={imageUrls[selectedIndex]}
            alt={`Gallery image ${selectedIndex + 1}`}
            className="image-gallery-lightbox-img"
          />

          {imageUrls.length > 1 && (
            <>
              <button
                className="image-gallery-nav image-gallery-prev"
                onClick={(e) => {
                  e.stopPropagation()
                  handlePrev()
                }}
                title="Previous image"
              >
                ‹
              </button>
              <button
                className="image-gallery-nav image-gallery-next"
                onClick={(e) => {
                  e.stopPropagation()
                  handleNext()
                }}
                title="Next image"
              >
                ›
              </button>
              <div className="image-gallery-counter-large">
                {selectedIndex + 1} / {imageUrls.length}
              </div>
            </>
          )}
        </div>
      )}
    </>
  )
}
